import { Box, Typography, useMediaQuery } from '@material-ui/core';
import BarcodeIcon from '../../../../images/icons/barCodes/barCodeDarkGrayOutline.svg';
import { ExpirationCardContainer } from '../styles';

const ExpirationCard = ({
  status,
  quantity,
  label,
  mobileLabel,
  date,
  bgColor,
  hideLabels,
  onClick = () => {}
}) => {
  const isMobileScreen = useMediaQuery('(max-width: 600px)');
  return (
    <ExpirationCardContainer
      className="defaultExpirationCard"
      bgColor={bgColor}
      isMobileScreen={isMobileScreen}
      onClick={onClick}
    >
      <Typography style={{ fontSize: 17, fontWeight: 600 }}>
        {hideLabels ? mobileLabel || label : label}
      </Typography>

      <Typography>
        {!hideLabels && <span>QTDE: </span>}
        {quantity}
        {!hideLabels && <span> produtos</span>}
      </Typography>

      <Box borderTop="1px solid #010311" className="pt3 mt3">
        <Box className="dFlex alignCenter justifyBetween">
          <Box style={{ flex: 1 }}>
            <Typography>
              {!hideLabels && <span>Validade: </span>} <strong>{status}</strong>
            </Typography>

            <Typography>
              {!hideLabels && <span>Data: </span>} {date}
            </Typography>
          </Box>

          {!hideLabels && <img width={'55px'} src={BarcodeIcon} />}
        </Box>
      </Box>
    </ExpirationCardContainer>
  );
};

export default ExpirationCard;
